import React from 'react';
import { Typography } from 'antd';

const { Title, Text } = Typography;

export default function AdminPageHeader({ title, subtitle, extra }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 24,
        gap: 12,
        flexWrap: 'wrap',
      }}
    >
      <div>
        <Title
          level={3}
          style={{ margin: 0, color: 'var(--df-text)', fontFamily: 'var(--df-font-display)' }}
        >
          {title}
        </Title>
        {subtitle ? (
          <Text style={{ fontSize: 13, color: 'var(--df-text-secondary)' }}>{subtitle}</Text>
        ) : null}
      </div>
      {extra || null}
    </div>
  );
}

export const adminPanelStyle = {
  borderRadius: 12,
  border: '1px solid var(--df-border)',
  background: 'var(--df-surface-elevated)',
  boxShadow: 'var(--df-shadow)',
  overflow: 'hidden',
};
